import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function convertToAMPM(time: string | Array<any>): string {
    // https://stackoverflow.com/a/13899011/9433691
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  }

  return {
    convertToAMPM,
  };
}
